export const popularizeModal = {
  description: "感谢您选择福昕家装，解决方案专家将尽快联系您~",
  placeholder: {
    entName: "请输入您所在的企业名称",
    name: "请输入您的姓名",
    post: "请选择您的职务",
    phoneNum: "请输入您的手机号"
  },
  submitButton: "提交信息",
  footer: {
    mainMessage: "扫码添加福昕家装微信客服",
    subMessage: "即可获取一对一解决方案"
  },
  messageModal: {
    QRCode: {
      title: "福昕家装微信客服",
      description: "为您提供一对一解决方案咨询",
      optDescription: "扫码二维码，添加微信客服"
    },
    prompt: {
      title: "提交成功",
      description: "我们已收到您的申请，会尽快联系您",
      invalid: '请正确填写您的信息',
      invalidPhone: '手机号码格式错误'
    },
    successTip: {
      submitSuccess: '提交成功！',
      submitSuccessMessage: ' 唤醒微信客服，回复 “问题关键词序号”',
      submitSuccessMessage1: '可加快申请通过速度',
      submitSuccessMessage2: '点击去唤醒',
    }
  },
  postList: {
    boss: '老板/总监/经理',
    designer: '设计师',
    manager: '项目经理/工长',
    scale: '销售/店长/导购/个体经营',
    personal: '学生/业主',
    habit: '个人爱好',
    other: '其他'
  }
}
